<style lang="less">
.confirm {
	width: 35% !important;

	p {
		overflow: initial;
		white-space: initial !important;
	}
}

.elicon {
	display: none !important;
	font-size: 2rem;
	margin-right: 0.4rem;
	color: #22af47;
	position: absolute;
	right: 53%;
	top: 3%;
	cursor: pointer;
}

.uplog:hover {
	.elicon {
		display: block !important;
	}
}
</style>
<style scoped lang="less">
// @import url("@/assets/helang-flex.scss");

.sleted {
	outline: 0 #ced4da;
	display: block;
	width: 100%;
	padding: 0.4375rem 0.75rem;
	font-size: 0.75rem;
	font-weight: 600;
	line-height: 1.5;
	/* color: var(--app-component-color); */
	color: #4c3e3e;
	background-color: var(--app-component-bg);
	background-clip: padding-box;
	border: 1px solid #ced4da;
}

/deep/ .el-descriptions-item__cell {
	width: 2vw;
	text-align: center !important;
}

/deep/ .el-dialog__header {
	padding: 14px 19px 10px;
	background: #05a34a;
	color: #fff !important;
	font-size: 1.2rem;

	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 1.4rem;
	}

	.el-dialog__title {
		color: #fff !important;
	}

	.dialog-header-title {
		span {
			margin-left: 0.6rem;
		}
	}
}

.appendschool {
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	justify-content: space-around;
	border-left: 3px solid #ffc107;
	border-radius: 2px;
	margin-bottom: 1rem;

	.appendschoolicon {
		margin: 0 1rem;
		width: 2rem;
		height: 2rem;
		background: #ffc107;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 1.4rem;
		border-radius: 50%;
	}

	.appconten {
		.appchooltitle {
			font-size: 1.2rem;
			color: #333;
			font-weight: 500;
			width: 100%;
			border-bottom: 1px solid #ccc;
			padding-bottom: 0.6rem;
			margin-bottom: 1rem;
			box-sizing: border-box;
		}

		/deep/ .el-row {
			margin: 0 0 0.8rem 0;

			p {
				margin: 0 0 0.4rem 0;
			}
		}

		.uplog {
			display: flex;
			align-items: center;
			position: relative;

			button {
				margin-bottom: 1.2rem;
				border: 1px dashed #ccc;
				padding: 0.4rem 1rem;
				border-radius: 1rem;

				i {
					font-size: 1rem;
					margin-right: 0.4rem;
					color: #22af47;
				}
			}

			img {
				width: 4rem;
				height: 4rem;
				margin-left: 1rem;
				margin-top: -1rem;
			}
		}
	}
}

.uplog {
	display: flex;
	align-items: center;

	p {
		margin-bottom: 1.2rem;
		border: 1px dashed #ccc;
		padding: 0.4rem 1rem;
		border-radius: 1rem;

		i {
			font-size: 1rem;
			margin-right: 0.4rem;
			color: #22af47;
		}
	}

	img {
		width: 4rem;
		height: 4rem;
		margin-left: 1rem;
		margin-top: -1rem;
	}
}

.schoollist {
	// margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #22af47;
	border-radius: 2px;

	.schooltitle {
		font-size: 1.2rem;
		color: #22af47;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		button {
			padding: 0.4rem;
			background: #ffc107;
			font-size: 0.8rem;
			border-radius: 3px;
			margin: 0 1rem;

			span {
				color: #000;
			}
		}

		span.el-icon-s-management {
			display: block;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 1rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #22af47;
			color: #fff;
		}
	}
}

.tabslis {
	/deep/ & ::-webkit-scrollbar {
		width: 5px;
		height: 8px;
		background: linear-gradient(to right, #2e61bf, #60c363);
	}

	& ::-webkit-scrollbar {
		width: 10px;
		height: 5px;
		// background: red;
	}

	& ::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	/deep/ .el-table {
		th,
		td {
			// text-align: center;
			height: 4rem;
		}

		tr:nth-child(2n) {
			background-color: #fff;
		}

		tr:nth-child(2n-1) {
			background-color: #f2f2f2;
		}

		td {
			button {
				color: #fff;
				border-radius: 5px;
			}

			.looking {
				background: #0d6efd;
				margin-left: 10px;

				span {
					font-size: 1.2rem;
				}
			}

			.looking:hover {
				background: #0b67e6;
			}

			.giveempower {
				background: #ff8300;

				span {
					font-size: 1.2rem;
				}
			}

			.edit {
				background: #17a001;

				span {
					font-size: 1.2rem;
				}
			}

			.edit:hover {
				background: #1fcf00;
			}

			.delete {
				background: #ec0f25;

				span {
					font-size: 1.2rem;
				}
			}

			.delete:hover {
				background: #ff1128;
			}
		}
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.schoolconten {
		p {
			// height: 4rem;
			overflow: hidden;
			white-space: pre-wrap !important;
			text-overflow: ellipsis;
			text-align: left;
		}
		word-break: break-all;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;

		text-overflow: ellipsis;
	}

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.swipers {
	/deep/ .el-switch {
		z-index: 1;
	}

	/deep/ .switchStyle .el-switch__label {
		position: absolute;
		display: none;
		color: #ffffff;
	}

	/deep/ .switchStyle .el-switch__label--left {
		z-index: 9;
		left: 25px;
	}

	/deep/ .switchStyle .el-switch__label--right {
		z-index: 9;
		left: 0px;
		top: 0;
	}

	/deep/ .switchStyle .el-switch__label.is-active {
		display: block;
	}

	/deep/ .switchStyle.el-switch .el-switch__core,
	/deep/ .el-switch .el-switch__label {
		width: 60px !important;
	}
}

/* 动画 */
@keyframes danchu {
	from {
		transform: translateX(-100%);
		opacity: 0;
	}

	to {
		opacity: 1;
		transform: translateX(0px);
	}
}

.v-enter-active {
	animation: danchu 1s linear;
}

.v-leave-active {
	animation: danchu 1s linear reverse;
}

.deletechioes {
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: center;
	position: relative;

	.delechow {
		position: absolute;
		left: 1%;
		padding: 0.6rem;
		background: #ff4168;
		color: #fff;
		border-radius: 5px;

		span {
			font-size: 1rem;
		}
	}

	ul {
		display: flex;
		align-self: center;
		width: 20vw;

		li {
			border-right: 1px solid #61b87e;
			border-top: 1px solid #61b87e;
			border-bottom: 1px solid #61b87e;
			padding: 0.2rem;
			width: 10vw;
			text-align: center;
			font-size: 0.8rem;

			span {
				vertical-align: middle;
				color: #61b87e;
			}
		}

		li:first-child {
			border-left: 1px solid #61b87e;
			border-top-left-radius: 2px;
			border-bottom-left-radius: 2px;
		}

		li:last-child {
			border-top-left-radius: 2px;
			border-bottom-left-radius: 2px;
		}
	}
}

.addscools {
	button {
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid transparent;
		padding: 0.4rem 2rem;
		border-radius: 1rem;
		background: #ffc107;
		color: #fff;
	}
}

.grid-content {
	margin: 0.4rem 0;

	p {
		margin: 0.4rem 0;
	}
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}

.elicon {
	display: flex;
	align-items: center;
	justify-content: space-around;

	i {
		display: block;
		padding: 0.5rem;
		border: 1px solid #ccc;
		border-radius: 50%;
		font-size: 1rem;
		cursor: pointer;
	}
}
</style>
<template>
	<div>
		<titles titlename="院校管理" titlecontent="这里可以管理院校" :mbx="paths"></titles>

		<transition>
			<div class="appendschool" v-if="isShow">
				<div class="appendschoolicon"><span class="el-icon-s-management"></span></div>
				<div class="appconten" style="width: 100%;">
					<p class="appchooltitle">添加院校</p>
					<form>
						<el-row :gutter="20">
							<el-col :span="12">
								<div class="grid-content ">
									<p>院校logo</p>
									<div class="uplog">
										<p @click.stop="uploadFile()" style="cursor: pointer;">
											<i class="el-icon-upload"></i>
											点击这里选择上传图片
										</p>
										<input v-show="false" ref="fileRef" type="file" accept="image/*" @change="fileChange" />

										<img style="border-radius: 50%;" v-if="corappurl !== null" :src="corappurl" alt="" />
										<i v-if="corappurl !== null" @click="centerDialogVisible = true" class="el-icon-upload elicon"></i>
									</div>
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<div class="grid-content">
									<p>
										院校中文名称
										<span style="color: red;margin-left: 4px;">(必填)</span>
									</p>
									<input v-model="scoolobj.si_name_cn" type="text" class="form-control" id="inlineFormInput" placeholder="输入院校名称" />
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-content ">
									<p>院校简称</p>
									<input v-model="scoolobj.si_name_sn" type="text" class="form-control" id="inlineFormInput" placeholder="输入院校简称" />
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<div class="grid-content ">
									<p>院校英文名称</p>
									<input v-model="scoolobj.si_name_en" type="text" class="form-control" id="inlineFormInput" placeholder="输入院校名称" />
								</div>
							</el-col>
							<el-col :span="12">
								<div class="grid-content ">
									<p>
										所属省份
										<span style="color: red;margin-left: 4px;">(必填)</span>
									</p>
									<div class="uplog">
										<select v-model="scoolobj.schooldiz" class="sleted fs-13px">
											<option value="">所属省份</option>
											<option v-for="(item, index) in schooldiz" :key="index" :value="item.Id">{{ item.Name }}</option>
										</select>
									</div>
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="24">
								<div class="grid-content">
									<p>关联专业</p>
									<div style="margin: 15px 0;"></div>
									<el-checkbox-group v-model="zyobjs">
										<el-checkbox v-for="zyactive in zylists" :label="zyactive.pro_guid" :key="zyactive.pro_guid">{{ zyactive.pro_name }}</el-checkbox>
									</el-checkbox-group>
								</div>
							</el-col>
						</el-row>

						<el-row :gutter="20">
							<el-col :span="24">
								<div class="grid-content">
									<p>院校简介</p>
									<textarea rows="10" v-model="scoolobj.si_name_dn" type="text" class="form-control" id="inlineFormInput" placeholder="输入院校院校简介" />
								</div>
							</el-col>
						</el-row>
					</form>
					<div class="addscools" style="margin-top: 1rem; display: flex;align-items: center;justify-content: center;">
						<button rows="4" cols="50" @click.stop="addschool()" v-preventReClick>点击添加</button>
					</div>
				</div>
			</div>
		</transition>

		<el-dialog :show-close="false" :title="titlesa" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<div v-if="containsnum == 1">
				<el-descriptions class="margin-top" title="院校详情" :column="1" border>
					<el-descriptions-item>
						<template slot="label" style="width: 20vw;">
							院校logo
						</template>
						<el-popover placement="top-start" title="" trigger="hover">
							<img :src="scoolchxq.si_pictureUrl" alt="" style="width: 150px;height: 150px" />
							<img slot="reference" :src="scoolchxq.si_pictureUrl" style="width: 40px;height: 40px" />
						</el-popover>
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							院校中文名称
						</template>
						{{ scoolchxq.si_name_cn }}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							院校英文名称
						</template>
						{{ scoolchxq.si_name_en }}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							院校简称
						</template>
						{{ scoolchxq.si_name_sn }}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							院校简介
						</template>
						{{ scoolchxq.si_name_dn }}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							状态
						</template>
						{{ scoolchxq.si_status ? '启用' : '禁用' }}
					</el-descriptions-item>
				</el-descriptions>
			</div>

			<div v-if="containsnum == 2">
				<form>
					<el-row :gutter="20">
						<el-col :span="12">
							<div class="grid-content">
								<p>院校中文名称</p>
								<input v-model="changescoolobj.si_name_cn" type="text" class="form-control" id="inlineFormInput" placeholder="输入院校名称" />
							</div>
						</el-col>
						<el-col :span="12">
							<div class="grid-content ">
								<p>院校简称</p>
								<input v-model="changescoolobj.si_name_sn" type="text" class="form-control" id="inlineFormInput" placeholder="输入院校简称" />
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<div class="grid-content ">
								<p>院校英文名称</p>
								<input v-model="changescoolobj.si_name_en" type="text" class="form-control" id="inlineFormInput" placeholder="输入院校名称" />
							</div>
						</el-col>
						<el-col :span="12">
							<div class="grid-content ">
								<p>所属省份</p>
								<select v-model="changescoolobj.schooldiz" class="sleted fs-13px">
									<option value="">所属省份</option>
									<option v-for="(item, index) in schooldiz" :key="index" :value="item.Id">{{ item.Name }}</option>
								</select>
							</div>
						</el-col>
						<el-col :span="24">
							<div class="grid-content">
								<p>院校logo</p>
								<div class="uplog">
									<p @click="uploadFiles()" style="cursor: pointer;">
										<i class="el-icon-upload"></i>
										点击这里选择上传图片
									</p>
									<input v-show="false" ref="fileRefs" type="file" accept="image/*" @change="fileChanges" />
									<img style="border-radius: 50%;" alt="这是学校的logo" v-if="changescoolobj.si_pictureUrl !== null" :src="changescoolobj.si_pictureUrl" />
								</div>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<div class="grid-content">
								<p>关联专业</p>
								<div style="margin: 15px 0;"></div>
								<el-checkbox-group v-model="zyobjs">
									<el-checkbox v-for="zyactive in zylists" :label="zyactive.pro_guid" :key="zyactive.pro_guid">{{ zyactive.pro_name }}</el-checkbox>
								</el-checkbox-group>
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<div class="grid-content">
								<p>院校简介</p>
								<el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="changescoolobj.si_name_dn"></el-input>
							</div>
						</el-col>
					</el-row>
				</form>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogchengedelete()" v-preventReClick>取 消</el-button>
				<el-button type="primary" @click="dialogvschange()" v-preventReClick>确 定</el-button>
			</span>
		</el-dialog>

		<div class="schoollist">
			<div class="schooltitle">
				<div style="display: flex;align-items: center;">
					<span class="el-icon-s-management"></span>
					<span>院校数据列表</span>

					<el-tooltip class="item" effect="dark" :content="isShow ? '隐藏功能区' : '显示功能区'" placement="bottom-start">
						<button :title="isShow ? '隐藏功能区' : '显示功能区'" @click="tapaddschool()">
							<span class="icon-user-follow"></span>
							添加院校
						</button>
					</el-tooltip>
				</div>
				<div style="position: absolute;right: 1%;display: flex;align-items: center;">
					<input
						style="width: 22rem;margin-right: 1rem;"
						v-model="changename"
						@input="inputname()"
						type="text"
						class="form-control"
						id="inlineFormInput"
						placeholder="输入院校名称"
					/>
					<select @change="scoolchanges()" class="sleted fs-13px" style="border-radius: 5px;" v-model="si_province">
						<option value="0">请选择省份</option>
						<option v-for="(item, index) in schooldiz" :key="item.Id" :value="item.Id">{{ item.Name }}</option>
					</select>
				</div>
			</div>

			<div class="tables">
				<div class="tabslist">
					<!-- <div class="paginations">
						每页显示
						<input type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" @change="changenum()" />
						行
					</div> -->
					<div class="tabslis" style="margin-top: 10px;">
						<template>
							<el-table
								@select="selectionRow"
								header-row-class-name="tablestitle"
								@select-all="selectionRowAll"
								:data="tableData"
								border
								style="width: 100%"
								:default-sort="{ prop: 'numid', order: 'descending' }"
							>
								<el-table-column fixed :resizable="false" type="selection" width="55"></el-table-column>
								<el-table-column prop="si_name_sn" :resizable="false" label="院校简称">
									<template slot-scope="scope">
										<p :title="scope.row.si_name_sn" style="text-align: left;">{{ scope.row.si_name_sn }}</p>
									</template>
								</el-table-column>
								<el-table-column prop="si_name_cn" :resizable="false" label="院校名称">
									<template slot-scope="scope">
										<p :title="scope.row.si_name_cn" style="text-align: left;">{{ scope.row.si_name_cn }}</p>
									</template>
								</el-table-column>
								<el-table-column prop="si_provinceName" :resizable="false" width="120" label="所属省份"></el-table-column>

								<el-table-column label="院校logo" :resizable="false" width="100">
									<template slot-scope="scope">
										<div style="width: 100%;text-align: center;">
											<el-popover placement="top-start" title="" trigger="hover">
												<img v-if="scope.row.si_pictureUrl == null" src="../../images/gtsdschool.png" alt="" style="width: 150px;height: 150px;" />
												<img v-if="scope.row.si_pictureUrl != null" :src="scope.row.si_pictureUrl" alt="" style="width: 150px;height: 150px;" />
												<img v-if="scope.row.si_pictureUrl == null" slot="reference" src="../../images/gtsdschool.png" style="width: 40px;height: 40px;" />
												<img v-if="scope.row.si_pictureUrl != null" slot="reference" :src="scope.row.si_pictureUrl" style="width: 40px;height: 40px;" />
											</el-popover>
										</div>
									</template>
								</el-table-column>
								<el-table-column label="院校简介" :resizable="false" width="500">
									<template slot-scope="scope">
										<div class="schoolconten" :title="scope.row.si_name_dn">{{ scope.row.si_name_dn }}</div>
									</template>
								</el-table-column>
								<el-table-column prop="studs" :resizable="false" label="状态" width="110">
									<template slot-scope="scope">
										<div class="swipers">
											<el-switch
												style="display: block"
												v-model="scope.row.si_status"
												active-color="#00cc77"
												class="switchStyle"
												inactive-color="#F00000"
												active-text="启用"
												inactive-text="禁用"
												:active-value="true"
												:inactive-value="false"
												@change="switchChangeFin(scope.row)"
											></el-switch>
										</div>
									</template>
								</el-table-column>
								<el-table-column fixed="right" label="操作" width="240">
									<template slot-scope="scope">
										<div class="userusec d-sm-none d-md-block">
											<el-button size="small" :class="'looking'" @click="lookinscool(scope.row)">
												<el-tooltip class="item" effect="dark" content="查看" placement="bottom-end"><span class="el-icon-view"></span></el-tooltip>
											</el-button>
											<el-button size="small" @click="handleClick(scope.row)" class="edit">
												<el-tooltip class="item" effect="dark" content="编辑" placement="bottom-end"><span class="fas fa-eye-dropper"></span></el-tooltip>
											</el-button>
											<el-button size="small" class="delete" @click="tabledeletes(scope.row)">
												<el-tooltip class="item" effect="dark" content="删除" placement="bottom-end"><span class="el-icon-delete"></span></el-tooltip>
											</el-button>
										</div>
										<div class="userusec d-sm-block d-md-none">
											<el-dropdown trigger="click">
												<p class="el-dropdown-link">···</p>
												<el-dropdown-menu slot="dropdown">
													<el-button size="small" :class="'looking'" @click="lookinscool(scope.row)">
														<el-tooltip class="item" effect="dark" content="查看" placement="bottom-end"><span class="el-icon-view"></span></el-tooltip>
													</el-button>
													<el-button size="small" @click="handleClick(scope.row)" class="edit">
														<el-tooltip class="item" effect="dark" content="编辑" placement="bottom-end">
															<span class="fas fa-eye-dropper"></span>
														</el-tooltip>
													</el-button>
													<el-button size="small" class="delete" @click="tabledeletes(scope.row)">
														<el-tooltip class="item" effect="dark" content="删除" placement="bottom-end">
															<span class="el-icon-delete"></span>
														</el-tooltip>
													</el-button>
												</el-dropdown-menu>
											</el-dropdown>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</div>
					<div class="tabsnum">
						<p>
							显示
							<span>1</span>
							到
							<span>{{ tabsnun }}</span>
							,共
							<span>{{ totals }}</span>
							条记录
						</p>
						<div class="elpagian">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								background
								layout="prev, pager, next"
								:page-size="tabsnun"
								:total="totals"
							></el-pagination>
						</div>
					</div>

					<div class="deletechioes">
						<button class="delechow" @click="deletescools()" v-preventReClick>
							<span class="el-icon-delete"></span>
							删除选中项
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- 上传图片截取事件 -->
		<el-dialog title="修改头像" :visible.sync="centerDialogVisible" center width="80%">
			<div style="display: flex;align-items: center;justify-content: center;">
				<div style="display: flex;align-items: center;flex-direction: column;">
					<div style="width: 30rem;height: 30rem;">
						<vueCropper
							ref="cropper"
							:img="images"
							:outputSize="option.outputSize"
							:outputType="option.outputType"
							:info="option.info"
							:full="option.full"
							:canMove="option.canMove"
							:canMoveBox="option.canMoveBox"
							:original="option.original"
							:autoCrop="option.autoCrop"
							:autoCropWidth="option.autoCropWidth"
							:autoCropHeight="option.autoCropHeight"
							:fixedBox="option.fixedBox"
							@realTime="realTime"
						></vueCropper>
					</div>
				</div>

				<div
					style="width: 30rem;
						display: flex;
						justify-content: center;
						align-items: center;
						margin-left: 1rem;"
				>
					<img :src="corappurl" alt="" style="width: 10rem;height: 10rem;border-radius: 50%;border: 1px solid #ccc;" />
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cleerdialog">取 消</el-button>
				<el-button type="primary" @click="corappurloks">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { getSchoolList, DeleteListSchool, DeleteSchool, getInsertOrEdit, getSchoolEditStatus, GetProvinceListSchool, getPageProfList } from '@/request/api/mange/mange.js';
import { changeUploadFileAsync } from '@/request/api/homesview/yunhomes/yunhom';
import { VueCropper } from 'vue-cropper';
import AppOptions from '@/config/AppOptions.vue';

let time;
export default {
	data() {
		return {
			// 截取图片
			option: {
				img: '', // 裁剪图片的地址
				info: true, // 裁剪框的大小信息
				outputSize: 0.8, // 裁剪生成图片的质量
				outputType: 'jpeg', // 裁剪生成图片的格式
				canScale: false, // 图片是否允许滚轮缩放
				autoCrop: true, // 是否默认生成截图框
				autoCropWidth: 200, // 默认生成截图框宽度
				autoCropHeight: 200, // 默认生成截图框高度
				fixedBox: false, // 固定截图框大小 不允许改变
				fixed: false, // 是否开启截图框宽高固定比例
				fixedNumber: [5, 0], // 截图框的宽高比例
				full: true, // 是否输出原图比例的截图
				canMoveBox: true, // 截图框能否拖动
				original: true, // 上传图片按照原始比例渲染
				centerBox: true, // 截图框是否被限制在图片里面
				infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
			},
			centerDialogVisible: false,
			corappurl: null,
			// 按钮
			titlesa: '',
			containsnum: 1,
			// 学校详情
			scoolchxq: {},
			// 添加学校
			scoolobj: {
				schooldiz: '',
				filename: '',
				si_guid: '',
				si_name_cn: '',
				si_name_en: '',
				si_name_sn: '',
				si_name_dn: '',
				si_remark: '',
				si_province: ''
			},
			filenames: {},
			// 文件上传
			file: '',
			images: null,
			// 动画显示隐藏
			isShow: false,
			// 页面数量
			tabsnun: 10,
			tableData: [],
			uploade: false,
			pageIndex: 1,
			totals: 0,
			// 标题组件
			paths: [
				{
					path: '/basicmanage/shoolmanage',
					name: '院校管理'
				}
			],
			siguidlist: [],
			// 弹窗
			dialogVisible: false,
			// 修改的对象
			changescoolobj: {
				si_guid: '',
				si_name_cn: '',
				si_name_en: '',
				si_name_sn: '',
				si_name_dn: '',
				si_remark: '',
				schooldiz: ''
			},
			filenameschange: null,
			// 院校地址
			schooldiz: [],
			// 院校id
			si_province: 0,
			// 院校名称
			changename: '',
			// 省份列表
			schoollist: [],
			previews: {},
			// 默认图片保存
			newfilenow: '',
			// 图片判断
			imagesnum: 0,
			zyobjs: [],
			zylists: [],
			imageurs: null
		};
	},
	beforeMount() {},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.getslistsc();

		let trs = document.querySelectorAll('tr');
		for (var i = 0; i < trs.length; i++) {
			trs[i].classList.add('animate__animated');
			trs[i].classList.add('animate__slideInLeft');
		}
		this.gettSchoolLists();
	},
	updated() {
		// console.log(this.images,"更新")
	},
	methods: {
		// 获取 专业不分页
		async getzylists() {
			let zylists = await getPageProfList({
				pageIndex: 1,
				pageSize: 200,
				pro_name: '',
				si_guid: ''
			});
			this.zylists = zylists.data.data.list;
			// console.log(zylists, '专业不分页');
		},
		getslistsc() {
			GetProvinceListSchool().then(res => {
				this.schooldiz = res.data.data;
			});
		},

		// 真实图片
		realTime(data) {
			// console.log(data);
			this.previews = data;
			let _this = this;
			this.$refs.cropper.getCropBlob(async data1 => {
				// let formData = new FormData();
				// console.log(data1, '获取data1');
				if (data1) {
					var timestamp = new Date().getTime() + '.jpg';
					//  将blob格式转换为文件。File() 构造器创建新的 File 对象实例。
					const newFile = new window.File([data1], timestamp);
					var src = window.URL.createObjectURL(newFile);
					// console.log(src, 'bese64');
					_this.newfilenow = newFile;
					_this.corappurl = src;

					if (_this.imagesnum == 2) {
						_this.changescoolobj.si_pictureUrl = src;
					}
				}
			});
		},

		// 改变省份
		scoolchanges() {
			this.gettSchoolLists();
		},

		inputname() {
			// 改变院校名称
			let that = this;
			if (time) {
				clearTimeout(time);
			}
			time = setTimeout(function() {
				that.gettSchoolLists();
				time = undefined;
			}, 1000);
		},
		// 添加院校
		tapaddschool() {
			this.isShow = !this.isShow;
			if (this.isShow) {
				this.getzylists();
			}
			this.zyobjs = [];
			this.scoolobj = {};
			this.scoolobj.schooldiz = '';
			this.corappurl = null;
			this.imagesnum = 0;
			this.centerDialogVisible = false;
			this.newfilenow = '';
		},

		// 公共返回
		handleClose(done) {
			done();
		},
		// 添加或者新增学校
		addschool(id = null, sinamefilnam = null, smzjytv = null) {
			// console.log(this.scoolobj, "提交")
			// console.log(this.scoolobj.filename, '编辑头像');
			let prolist = [];
			if (this.zyobjs && this.zyobjs.length > 0) {
				this.zyobjs.forEach(ite => {
					prolist.push({
						pro_guid: ite
					});
				});
			}

			let addschoolzyobj = {
				si_guid: '',
				si_name_cn: this.scoolobj.si_name_cn,
				si_name_en: this.scoolobj.si_name_en,
				si_name_sn: this.scoolobj.si_name_sn,
				si_name_dn: this.scoolobj.si_name_dn,
				si_remark: this.scoolobj.si_remark,
				si_pictureUrl: this.imageurs,
				si_province: this.scoolobj.schooldiz,
				SchoolOrPro: prolist
			};

			// data.append('si_guid', '');
			// data.append('si_name_cn', this.scoolobj.si_name_cn ?? '');
			// data.append('si_name_en', this.scoolobj.si_name_en ?? '');
			// data.append('si_name_sn', this.scoolobj.si_name_sn ?? '');
			// data.append('si_name_dn', this.scoolobj.si_name_dn ?? '');
			// data.append('si_remark', this.scoolobj.si_remark ?? '');
			// data.append('filename', sinamefilnam == null ? this.scoolobj.filename : '');
			// data.append('si_province', this.scoolobj.schooldiz ?? '');
			// console.log(this.scoolobj.si_name_cn)

			if (this.scoolobj.si_name_cn == undefined) {
				this.$message('院校中文名称不能为空');
			} else {
				getInsertOrEdit(addschoolzyobj).then(res => {
					// console.log(res.data.code);
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，添加院校成功!',
							type: 'success'
						});
						this.gettSchoolLists();
						this.scoolobj = {};
						this.scoolobj.filename = {};
						this.dialogVisible = false;
						this.images = null;
						this.scoolobj.schooldiz = '';
						this.corappurl = null;
						this.imagesnum = 0;
						this.centerDialogVisible = false;
						this.newfilenow = '';
						this.zyobjs = [];
					} else {
						this.$message(res.data.msg);
					}
				});
			}
		},
		addschools() {
			for (let key in this.changescoolobj) {
				if (this.changescoolobj[key] === null || this.changescoolobj[key] === 'null') {
					this.changescoolobj[key] = '';
				}
			}
			let prolist = [];
			if (this.zyobjs && this.zyobjs.length > 0) {
				this.zyobjs.forEach(ite => {
					prolist.push({
						pro_guid: ite
					});
				});
			}

			let addschoolzyobj = {
				si_guid: this.changescoolobj.si_guid,
				si_name_cn: this.changescoolobj.si_name_cn,
				si_name_en: this.changescoolobj.si_name_en,
				si_name_sn: this.changescoolobj.si_name_sn,
				si_name_dn: this.changescoolobj.si_name_dn,
				si_remark: this.changescoolobj.si_remark,
				si_pictureUrl: this.imageurs ? this.imageurs : this.changescoolobj.si_pictureUrl,
				si_province: this.changescoolobj.schooldiz,
				SchoolOrPro: prolist
			};

			if (this.changescoolobj.si_name_cn == undefined) {
				this.$message('院校中文名称不能为空');
			} else {
				getInsertOrEdit(addschoolzyobj).then(res => {
					// console.log(res.data.code);
					if (res.data.code == 1) {
						this.$message({
							message: '恭喜你，修改院校成功!',
							type: 'success'
						});
						this.gettSchoolLists();
						this.changescoolobj = {};
						this.filenameschange = {};
						this.dialogVisible = false;
						this.changescoolobj.schooldiz = '';
					} else {
						this.$message(res.data.msg);
					}
				});
			}
		},

		// 编辑按钮
		async handleClick(e) {
			// console.log(e);
			await this.getzylists();
			// this.SchoolOrPro
			this.changescoolobj = e;
			this.zyobjs = [];
			if (e.SchoolOrPro && e.SchoolOrPro.length > 0) {
				e.SchoolOrPro.forEach(ite => {
					this.zyobjs.push(ite.pro_guid);
				});
			}
			// console.log(e,'编辑按钮')
			this.imageurs = null;
			this.changescoolobj.schooldiz = e.si_province ?? '';
			this.changescoolobj.pathnames = e.si_pictureUrl;
			this.changescoolobj.si_pictureUrl = e.si_pictureUrl;
			this.containsnum = 2;
			this.dialogVisible = true;
			this.titlesa = e.si_name_cn + '编辑';
			this.corappurl = null;
			this.imagesnum = 0;
			this.centerDialogVisible = false;
			this.newfilenow = '';
		},

		// 编辑取消
		dialogchengedelete() {
			this.dialogVisible = false;
			this.changescoolobj.si_pictureUrl = this.changescoolobj.pathnames;
		},
		// 编辑确定按钮
		dialogvschange() {
			if (this.containsnum == 1) {
				this.dialogVisible = false;
			} else {
				this.addschools(this.scoolobj.si_guid, this.scoolobj.si_pictureUrl, 1);
			}
		},
		// 查看学校信息
		lookinscool(row) {
			this.titlesa = row.si_name_cn + '详情';
			this.containsnum = 1;
			this.scoolchxq = row;
			this.dialogVisible = true;
		},

		// 分页
		changenum() {
			this.gettSchoolLists();
		},
		// 单次删除
		tabledeletes(e) {
			this.$confirm('确定删除这条记录吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let School = {
						si_guid: e.si_guid,
						isDelete: 'false'
					};
					DeleteSchool(School).then(res => {
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你,' + res.data.msg + '！',
								type: 'success'
							});
							this.gettSchoolLists();
							// console.log('没记录删除');
						} else {
							this.$confirm(res.data.msg + `<div style='color:red;'>当前记录删除后会删除关联数据且不能恢复，请谨慎选择</div>`, '删除失败', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning',
								customClass: 'confirm',
								dangerouslyUseHTMLString: true
							})
								.then(() => {
									// console.log('有记录也删除');
									School = {
										si_guid: e.si_guid,
										isDelete: 'true'
									};
									DeleteSchool(School).then(res => {
										if (res.data.code == 1) {
											this.$message({
												message: '恭喜你,' + res.data.msg + '！',
												type: 'success'
											});
											this.gettSchoolLists();
											// console.log('没记录删除');
										}
									});
								})
								.catch(() => {});
						}
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},

		// 多次删除
		deletescools() {
			// console.log(this.siguidlist.length, this.siguidlist);
			if (this.siguidlist.length == 0) {
				this.$message('请选择需要删除的');
			} else {
				this.$confirm('确定删除选中的记录吗？', '提示', {
					confirmButtonText: '确定删除',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						let telistojb = {
							si_guid: this.siguidlist,
							isdelete: 'false'
						};

						// console.log(telistojb);
						DeleteListSchool(telistojb).then(res => {
							if (res.data.code == 1) {
								this.$message({
									message: '恭喜你,' + res.data.msg + '！请立即刷新页面！',
									type: 'success'
								});
								this.gettSchoolLists();
							} else {
								this.$confirm(res.data.msg + `<div style='color:red;'>当前记录删除后会删除关联数据且不能恢复，请谨慎选择</div>`, '提示', {
									confirmButtonText: '确定删除',
									cancelButtonText: '取消',
									type: 'warning',
									customClass: 'confirm',
									dangerouslyUseHTMLString: true
								})
									.then(() => {
										telistojb = {
											si_guid: this.siguidlist,
											isdelete: 'true'
										};

										// console.log(telistojb);
										DeleteListSchool(telistojb).then(res => {
											if (res.data.code == 1) {
												this.$message({
													message: '恭喜你,' + res.data.msg + '！请立即刷新页面！',
													type: 'success'
												});
												this.gettSchoolLists();
											} else {
											}
										});
									})
									.catch(() => {
										// console.log('后悔删除');
									});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			}
		},

		// 表格复选框事件
		selectionRow(selection, row) {
			// console.log(selection, '单选');
			// console.log(row, "单选")

			if (selection.length > 0) {
				let siguidlist = [];
				selection.forEach(item => {
					siguidlist.push(item.si_guid);
				});
				this.siguidlist = siguidlist;
			} else {
				this.siguidlist = [];
			}
		},

		//表格全选事件
		selectionRowAll(selection) {
			// console.log(selection, '多选');
			selection.forEach(item => {
				this.siguidlist.push(item.si_guid);
			});
		},
		// 获取院校列表
		gettSchoolLists() {
			let schoolobj = {
				pageIndex: this.pageIndex,
				pageSize: this.tabsnun,
				si_name_cn: this.changename,
				si_province: this.si_province
			};
			getSchoolList(schoolobj).then(res => {
				// console.log(res, '获取院校列表');
				this.tableData = res.data.data.list;
				this.totals = res.data.data.totalCount;

				this.tableData.forEach(item => {
					item.si_name_dn = item.si_name_dn == 'undefined' ? '' : item.si_name_dn;
					item.si_name_en = item.si_name_en == 'undefined' ? '' : item.si_name_en;
					item.si_name_sn = item.si_name_sn == 'undefined' ? '' : item.si_name_sn;
					item.si_remark = item.si_remark == 'undefined' ? '' : item.si_remark;
				});
				// console.log(this.tableData);
			});
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pageIndex = val;
			this.gettSchoolLists();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.pageIndex = val;
			this.gettSchoolLists();
		},

		switchChangeFin(e) {
			// console.log(e.si_status)
			let editstaobj = {
				si_guid: e.si_guid,
				si_status: e.si_status
			};
			getSchoolEditStatus(editstaobj).then(res => {
				if (res.data.code == 1) {
					// console.log(res.data.msg);
				} else {
					this.$message(res.data.msg);
				}
			});
		},
		uploadFile() {
			this.$refs.fileRef.click();
		},
		uploadFiles() {
			this.$refs.fileRefs.click();
		},
		handleCheckedCitiesChange() {
			// 修改专业
			console.log(this.zyobjs);
		},
		// 取消上传图片
		cleerdialog() {
			this.centerDialogVisible = false;
			this.scoolobj.filename = '';
			this.filenames = '';
			this.corappurl = null;
		},
		async corappurloks() {
			const fromdata = new FormData();
			if (this.containsnum == 2) {
				console.log(this.filenameschange, '获取filename');
				fromdata.append('filename', this.filenameschange);
			} else {
				fromdata.append('filename', this.scoolobj.filename);
			}
			let uploadfile = await changeUploadFileAsync(fromdata);
			this.corappurl = uploadfile.data.data.baseurl;
			this.changescoolobj.si_pictureUrl = uploadfile.data.data.baseurl;
			// console.log(uploadfile.data.data, '获取');
			this.imageurs = uploadfile.data.data.url;
			this.centerDialogVisible = false;
		},
		fileChange(e) {
			// 上传文件
			const files = e.target.files;
			// console.log(files[0]);
			this.file = files[0];
			this.getBase64(files);
			this.scoolobj.filename = files[0];
			this.filenames = files[0];

			if (e.target.files) {
				this.centerDialogVisible = true;
			}

			/* console.log(this.scoolobj);
			console.log('上传文件'); */
		},
		fileChanges(e) {
			const files1 = e.target.files;
			this.file = files1[0];
			this.getBase64(files1, 2);
			// this.changescoolobj.si_pictureUrl = files1[0];
			this.filenameschange = files1[0];
			// console.log(files1);
			this.centerDialogVisible = true;
		},

		getBase64(file, num) {
			// 图片预览
			var _this = this;
			var imas = '';
			for (var i = 0; i < file.length; i++) {
				var readIcon = new FileReader();
				readIcon.onload = function(e) {
					// 读成功，可预览
					// console.log(e.target.result);
					// imas =  e.target.result
					_this.images = e.target.result;

					_this.imagesnum = num;
					// if (num == 1) {
					// 	_this.scoolobj.filename = e.target.result;
					// } else {
					// 	_this.changescoolobj.si_pictureUrl = e.target.result;
					// }
					// _this.scoolobj.filename = e.target.result
				};
				readIcon.onerror = function(e) {
					alert('图片上传失败，请检查。');
				};
				readIcon.readAsDataURL(file[i]);
			}
		}
	},
	components: {
		titles,
		VueCropper
	}
};
</script>
